export default "__VITE_ASSET__1189e2db__"